/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as yup from "yup";
import { Edit, Warn } from "../../common/svg/AllSvg";
import { components } from "react-select";
import { url } from "../../../shared/utils/url";
import useAxios from "../../../shared/hooks/use-axios";
import SelectSecondaryComponent from "../../common/form/SelectSecondaryComponent";
import PrimaryInput from "../../common/form/PrimaryInput";
import PrimaryTextarea from "../../common/form/PrimaryTextarea";
import SecondaryBtn from "../../common/form/SecondaryBtn";
import { useSelector } from "react-redux";
import { numberOnPaste } from "../../../shared/utils/numberOnPaste";
import { Bounce, ToastContainer } from "react-toastify";
import { errors } from "../../../shared/utils/errors";

const DropdownIndicator = (props: any) => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>

            </components.DropdownIndicator>
        )
    );
};

const MedicalDetails = () => {
    const { t } = useTranslation('common');
    const lang: string = useSelector((state: any) => state.ui.lang);
    const [data, setData] = useState<any>([])
    const [edit, setEdit] = useState<boolean>(false)
    const [submit, setSubmit] = useState<boolean>(false);
    const choice: any[] = [{ label: t("recruitment.hr.candidate_detail.yes"), value: true }, { label: t("recruitment.hr.candidate_detail.no"), value: false }]
    const bloodGroup: any[] = [
        { label: "A+", value: "A+" },
        { label: "A-", value: "A-" },
        { label: "B+", value: "B+" },
        { label: "B-", value: "B-" },
        { label: "AB+", value: "AB+" },
        { label: "AB-", value: "AB-" },
        { label: "O+", value: "O+" },
        { label: "O-", value: "O-" }
    ]

    const relation: any[] = [
        { label: t("profile.relation.mother"), value: "Mother" },
        { label: t("profile.relation.father"), value: "Father" },
        { label: t("profile.relation.sibling"), value: "Sibling" },
        { label: t("profile.relation.spouse"), value: "Spouse" },
        { label: t("profile.relation.friend"), value: "Friend" },
        { label: t("profile.relation.other"), value: "Other" },
    ]

    const formik: any = useFormik({
        enableReinitialize: true,
        initialValues: {
            blood_group: !!data?.blood_group ? bloodGroup?.find?.((item: any) => item?.value === data?.blood_group) : '',
            emergency_contact1_name: !!data?.emergency_contact1_name ? data?.emergency_contact1_name : '',
            emergency_contact1_relation: !!data?.emergency_contact1_relation ? relation?.find?.((item: any) => item?.value === data?.emergency_contact1_relation) : '',
            emergency_contact1_phone: !!data?.emergency_contact1_phone ? data?.emergency_contact1_phone : '',
            emergency_contact2_name: !!data?.emergency_contact2_name ? data?.emergency_contact2_name : '',
            emergency_contact2_relation: !!data?.emergency_contact2_relation ? relation?.find?.((item: any) => item?.value === data?.emergency_contact2_relation) : '',
            emergency_contact2_phone: !!data?.emergency_contact2_phone ? data?.emergency_contact2_phone : '',
            any_medical_problem: data?.any_medical_problem ? { label: t("recruitment.hr.candidate_detail.yes"), value: true } : { label: t("recruitment.hr.candidate_detail.no"), value: false },
            medical_problem_details: !!data?.medical_problem_details ? data?.medical_problem_details : '',
            medication_name_dosage: !!data?.medication_name_dosage ? data?.medication_name_dosage : '',
            medication_frequency: !!data?.medication_frequency ? data?.medication_frequency : '',
            notes: !!data?.notes ? data?.notes : '',
        },
        validationSchema: yup.object().shape({
            blood_group: yup.object().required(t("profile.medical.err.blood_group")),
            emergency_contact1_name: yup.string().matches(/^[A-Za-z\s]+$/, t("contact_us.form.alpha_char_err")).required(t("profile.medical.err.e_name")),
            emergency_contact1_relation: yup.object().required(t("profile.medical.err.e_relation")),
            emergency_contact1_phone: yup.number().test('len', t("profile.medical.err.valid_phone"), (val: any) => val && val.toString().length === 10).required(t("profile.medical.err.e_phone")),
            emergency_contact2_name: yup.string().notRequired(),
            emergency_contact2_relation: yup.object().notRequired(),
            emergency_contact2_phone: yup.number().test('len', t("profile.medical.err.valid_phone"), (val: any) => {
                if (val) {
                    return val?.toString()?.length === 10;
                }
                return true;
            }),
            any_medical_problem: yup.object(),
            medical_problem_details: yup.object().when('any_medical_problem', (medical) => {
                if (medical && medical.some(item => item?.value === true)) {
                    return yup.string().required(t("profile.medical.err.medical_problem_details"));
                }
                return yup.string().notRequired();
            }),
            medication_name_dosage: yup.object().when('any_medical_problem', (medical) => {
                if (medical && medical.some(item => item?.value === true)) {
                    return yup.string().required(t("profile.medical.err.medication_name_dosage"));
                }
                return yup.string().notRequired();
            }),
            medication_frequency: yup.object().when('any_medical_problem', (medical) => {
                if (medical && medical.some(item => item?.value === true)) {
                    return yup.string().required(t("profile.medical.err.medication_frequency"));
                }
                return yup.string().notRequired();
            }),
            notes: yup.string().required(t("profile.medical.err.notes"))
        }),
        onSubmit: async (values: any) => {
            //submit
            try {
                setSubmit(true)
                const formData = new FormData();
                formData.append("blood_group", values?.blood_group?.value);
                formData.append("emergency_contact1_name", values?.emergency_contact1_name);
                formData.append("emergency_contact1_relation", values?.emergency_contact1_relation?.value);
                formData.append("emergency_contact1_phone", values?.emergency_contact1_phone);
                formData.append("emergency_contact2_name", values?.emergency_contact2_name);
                formData.append("emergency_contact2_relation", values?.emergency_contact2_relation?.value ? values?.emergency_contact2_relation?.value : null);
                formData.append("emergency_contact2_phone", values?.emergency_contact2_phone);
                formData.append("any_medical_problem", ((values?.any_medical_problem?.value) ? (true as any) : (false as any)));
                formData.append("notes", values?.notes);

                if (values?.any_medical_problem?.value) {
                    formData.append("medical_problem_details", values?.medical_problem_details);
                    formData.append("medication_name_dosage", values?.medication_name_dosage);
                    formData.append("medication_frequency", values?.medication_frequency);
                }

                const res: any = await useAxios.post(url?.medical, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (res && res?.status === 200) {
                    setSubmit(false);
                    getData();
                }
            } catch (error: any) {
                errors(error)
                setSubmit(false)
                console.error("error while change medical details", error);
            }
        }
    });

    const getData = async () => {
        try {
            const res: any = await useAxios.get(url?.medical);

            if (res && res.status === 200) {
                setData(res?.data)
            }
        } catch (error) {
            console.error("error while fetching medical details", error);
        }
    }

    useEffect(() => {
        getData();
    }, [])

    const handleEdit = () => {
        if (edit) {
            formik?.handleSubmit();
        } else {
            setEdit(true)
        }
    }

    useEffect(() => {
        if (edit) {
            const handleBeforeUnload = (event: any) => {
                event.preventDefault();
                event.returnValue = '';
            };
            window.addEventListener('beforeunload', handleBeforeUnload);

            return () => {
                window.removeEventListener('beforeunload', handleBeforeUnload);
            };
        }
    }, [edit]);

    useEffect(() => {
        if (!!formik?.values?.emergency_contact1_relation?.value) {
            let obj: any = relation?.find((item: any) => item?.value === formik?.values?.emergency_contact1_relation?.value)
            formik?.setFieldValue("emergency_contact1_relation", obj)
        }
        if (!!formik?.values?.emergency_contact2_relation?.value) {
            let obj: any = relation?.find((item: any) => item?.value === formik?.values?.emergency_contact2_relation?.value)
            formik?.setFieldValue("emergency_contact2_relation", obj)
        }
    }, [lang])

    return (
        <div className="flex flex-col w-full">
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
                transition={Bounce}
            />

            <div className="w-full flex items-center justify-between pb-[20px] px-[15px] md:p-[30px] xlx:p-[35px] border-b border-primary border-opacity-[0.2] gap-[15px]">
                <div className="flex flex-col gap-[5px]">
                    <h3 className="text-primaryText dark:text-white font-semibold">{t("profile.tabs.medical")}</h3>
                    <h6 className="text-blackDull dark:text-textBlackDull font-medium xsm:max-w-max max-w-[200px]">{t("profile.medical_desc")}</h6>
                </div>

                <SecondaryBtn css={`!rounded-[6px] ${!edit ? "px-[12px]" : "px-[24px]"} font-semibold !h-[35px] !gap-[8px] !text-base`} title={!edit ? t("profile.edit") : t("recruitment.hr.create_ad.field.save")} leftIcon={!edit && <Edit className="w-[17px] h-[17px] fill-white" />} onClick={handleEdit} disabled={edit ? submit : false} />
            </div>

            <div className="w-full h-full py-[20px] px-[15px] md:p-[30px] xlx:px-[35px] flex flex-col gap-[15px] xsm:gap-[20px] xlx:gap-[30px]">
                <div className="grid w-full grid-cols-1 msm:grid-cols-2 xl:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                    <div className="flex flex-col gap-[4px]">
                        <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("profile.medical.field.blood_group")}*`}</h6>
                        <SelectSecondaryComponent
                            options={bloodGroup}
                            name="blood_group"
                            placeholder={t("profile.medical.placehoder.blood_group")}
                            isSearchable={false}
                            arrow={true}
                            components={{ DropdownIndicator }}
                            onChange={(e: any) => formik.setFieldValue("blood_group", e)}
                            onBlur={(e: any) => formik.setFieldTouched("blood_group", e)}
                            value={formik.values.blood_group}
                            isDisabled={!edit}
                        />
                        {formik?.touched?.blood_group && formik?.errors?.blood_group && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.blood_group}</span>
                        </div>}
                    </div>
                </div>

                <div className="grid w-full grid-cols-1 msm:grid-cols-2 xl:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                    <div className="flex flex-col gap-[4px]">
                        <PrimaryInput title={`${t("profile.medical.field.e_name")}*`} name="emergency_contact1_name" type="text" placeholder={t("profile.medical.field.e_name")} value={formik?.values?.emergency_contact1_name} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
                        {formik?.touched?.emergency_contact1_name && formik?.errors?.emergency_contact1_name && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.emergency_contact1_name}</span>
                        </div>}
                    </div>

                    <div className="flex flex-col gap-[4px]">
                        <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("profile.medical.field.e_relation")}*`}</h6>
                        <SelectSecondaryComponent
                            options={relation}
                            name="emergency_contact1_relation"
                            placeholder={t("profile.medical.placehoder.e_relation")}
                            isSearchable={false}
                            arrow={true}
                            components={{ DropdownIndicator }}
                            onChange={(e: any) => formik.setFieldValue("emergency_contact1_relation", e)}
                            onBlur={(e: any) => formik.setFieldTouched("emergency_contact1_relation", e)}
                            value={formik.values.emergency_contact1_relation}
                            isDisabled={!edit}
                        />
                        {formik?.touched?.emergency_contact1_relation && formik?.errors?.emergency_contact1_relation && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.emergency_contact1_relation}</span>
                        </div>}
                    </div>

                    <div className="flex flex-col gap-[4px]">
                        <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("profile.medical.field.e_phone")}*`}</h6>
                        <div className="flex items-center gap-[10px] w-full">
                            <input className={`flex items-center justify-center px-[7px] w-[35px] xlx:w-[40px] h-[35px] xlx:h-[40px] rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] text-blackDull text-sm leading-snug disabled:opacity-[0.7] dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull disabled:dark:bg-bgDark`} defaultValue="+91" disabled autoComplete="off" />
                            <input className="placeholder:text-blackDull w-full rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] h-[35px] xlx:h-[40px] px-[15px] xlx:px-[17px] text-blackDull text-sm leading-snug disabled:opacity-[0.7] dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull disabled:dark:bg-bgDark" type="number" name="emergency_contact1_phone" placeholder={t("profile.medical.field.e_phone")} autoComplete="off" value={formik?.values?.emergency_contact1_phone} onBlur={formik?.handleBlur} onChange={formik?.handleChange} onFocus={(e: any) => e.target.addEventListener("wheel", function (e: any) { e.preventDefault() }, { passive: false })}
                                onKeyDown={(e: any) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()} disabled={!edit} onPaste={(e: any) => numberOnPaste(e)} />
                        </div>
                        {formik?.touched?.emergency_contact1_phone && formik?.errors?.emergency_contact1_phone && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.emergency_contact1_phone}</span>
                        </div>}
                    </div>
                </div>

                <div className="grid w-full grid-cols-1 msm:grid-cols-2 xl:grid-cols-3 gap-[15px] xlx:gap-[20px]">
                    <div className="flex flex-col gap-[4px]">
                        <PrimaryInput title={`${t("profile.medical.field.alt_e_name")}`} name="emergency_contact2_name" type="text" placeholder={t("profile.medical.field.e_name")} value={formik?.values?.emergency_contact2_name} onBlur={formik?.handleBlur} onChange={formik?.handleChange} disabled={!edit} />
                        {formik?.touched?.emergency_contact2_name && formik?.errors?.emergency_contact2_name && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.emergency_contact2_name}</span>
                        </div>}
                    </div>

                    <div className="flex flex-col gap-[4px]">
                        <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("profile.medical.field.alt_e_relation")}`}</h6>
                        <SelectSecondaryComponent
                            options={relation}
                            name="emergency_contact2_relation"
                            placeholder={t("profile.medical.placehoder.e_relation")}
                            isSearchable={false}
                            arrow={true}
                            components={{ DropdownIndicator }}
                            onChange={(e: any) => formik.setFieldValue("emergency_contact2_relation", e)}
                            onBlur={(e: any) => formik.setFieldTouched("emergency_contact2_relation", e)}
                            value={formik.values.emergency_contact2_relation}
                            isDisabled={!edit}
                        />
                        {formik?.touched?.emergency_contact2_relation && formik?.errors?.emergency_contact2_relation && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.emergency_contact2_relation}</span>
                        </div>}
                    </div>

                    <div className="flex flex-col gap-[4px]">
                        <h6 className="text-blackDark dark:text-textBlackDark font-medium">{`${t("profile.medical.field.alt_e_phone")}`}</h6>
                        <div className="flex items-center gap-[10px] w-full">
                            <input className={`flex items-center justify-center px-[7px] w-[35px] xlx:w-[40px] h-[35px] xlx:h-[40px] rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] text-blackDull text-sm leading-snug disabled:opacity-[0.7] dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull disabled:dark:bg-bgDark`} defaultValue="+91" disabled autoComplete="off" />
                            <input className="placeholder:text-blackDull w-full rounded-[6px] hover:bg-white focus:bg-white  bg-[#F5F5F5] border border-[#D7D8DD] h-[35px] xlx:h-[40px] px-[15px] xlx:px-[17px] text-blackDull text-sm leading-snug disabled:opacity-[0.7] dark:bg-bgDark dark:hover:bg-bgDarkDull dark:focus:bg-bgDarkDull dark:border-[#454545] dark:text-textBlackDull placeholder:dark:text-textBlackDull disabled:dark:bg-bgDark" type="number" name="emergency_contact2_phone" placeholder={t("profile.medical.field.e_phone")} autoComplete="off" value={formik?.values?.emergency_contact2_phone} onBlur={formik?.handleBlur} onChange={formik?.handleChange} onFocus={(e: any) => e.target.addEventListener("wheel", function (e: any) { e.preventDefault() }, { passive: false })}
                                onKeyDown={(e: any) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()} disabled={!edit} onPaste={(e: any) => numberOnPaste(e)} />
                        </div>
                        {formik?.touched?.emergency_contact2_phone && formik?.errors?.emergency_contact2_phone && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.emergency_contact2_phone}</span>
                        </div>}
                    </div>
                </div>

                <div className="flex flex-col gap-[4px]">
                    <h6 className="text-blackDark dark:text-textBlackDark font-medium">{t("profile.medical.field.any_medical_problem")}</h6>
                    <div className="flex items-center gap-[10px]">
                        {Array.isArray(choice) && choice?.map((item: any, index: number) => (
                            <button key={index} className={`${(formik?.values?.any_medical_problem?.value === item?.value) ? "border border-primary bg-primary text-white focus:shadow-[0_0_0_2px_#059db25e] hover:shadow-[0_0_0_2px_#059db25e]" : "border border-blackDull bg-white text-blackDull focus:shadow-[0_0_0_2px_#4e566d5e] hover:shadow-[0_0_0_2px_#4e566d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]"} rounded-[10px] h-[35px] xlx:h-[40px] px-[12px] text-sm leading-snug font-normal disabled:opacity-[0.7] disabled:shadow-none disabled:dark:shadow-none`} onClick={() => formik.setFieldValue("any_medical_problem", item)} disabled={!edit}>{item?.label}</button>
                        ))}
                    </div>
                </div>

                {formik?.values?.any_medical_problem?.value && <div className="grid w-full grid-cols-1 msm:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                    <div className="flex flex-col gap-[4px]">
                        <PrimaryTextarea title={`${t("profile.medical.field.medical_problem_details")}*`} placeholder={t("profile.medical.field.medical_problem_details")} rows="4" name="medical_problem_details" value={formik?.values?.medical_problem_details} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                        {formik?.touched?.medical_problem_details && formik?.errors?.medical_problem_details && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.medical_problem_details}</span>
                        </div>}
                    </div>

                    <div className="flex flex-col gap-[4px]">
                        <PrimaryTextarea title={`${t("profile.medical.field.medication_name_dosage")}*`} placeholder={t("profile.medical.field.medication_name_dosage")} rows="4" name="medication_name_dosage" value={formik?.values?.medication_name_dosage} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                        {formik?.touched?.medication_name_dosage && formik?.errors?.medication_name_dosage && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.medication_name_dosage}</span>
                        </div>}
                    </div>

                    <div className="flex flex-col gap-[4px]">
                        <PrimaryTextarea title={`${t("profile.medical.field.medication_frequency")}*`} placeholder={t("profile.medical.field.medication_frequency")} rows="4" name="medication_frequency" value={formik?.values?.medication_frequency} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                        {formik?.touched?.medication_frequency && formik?.errors?.medication_frequency && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.medication_frequency}</span>
                        </div>}
                    </div>
                </div>}

                <div className="grid w-full grid-cols-1 msm:grid-cols-2 gap-[15px] xlx:gap-[20px]">
                    <div className="flex flex-col gap-[4px]">
                        <PrimaryTextarea title={`${t("profile.medical.field.notes")}*`} placeholder={t("recruitment.profile.placehoder.start_tying")} rows="4" name="notes" value={formik?.values?.notes} onBlur={formik?.handleBlur} onChange={formik?.handleChange} />
                        {formik?.touched?.notes && formik?.errors?.notes && <div className="flex gap-[6px] items-start"><Warn />
                            <span className="text-danger dark:text-darkDanger text-xs font-medium">{formik?.errors?.notes}</span>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MedicalDetails;